
import { Base } from '../base-component';
import './artwork-tile.component.scss';

export class ArtworkTile extends Base {

	constructor(element: Element){

		super(element);

	}

	init(){

	}

	bindEvents() {

	}
}


// WEBPACK FOOTER //
// ./components/artwork-tile/artwork-tile.component.ts